export default {
    DADATA: process.env.REACT_APP_DADATA_TOKEN,
};
